export default __webpack_public_path__ + "static/media/Chevron-up2.b30b39eb.svg";